import React from "react";
import ImageWrapper from "../ImageComponent/ImageWrapper";

const InputTextComponent = ({ data, onInputChange, value }) => {
  const { type, placeholder, options, required, label, image } = data;

  return (
    <fieldset className="border border-light-grey-color w-full h-12 rounded-md ">
      <legend className="mx-3 px-1 text-xs">
        {label}
        {required ? "*" : ""}
      </legend>
      <div className="flex flex-row justify-start items-center px-4">
        <div className="relative w-4 h-4">
          <ImageWrapper
            src={image ? image : "/icons/Profile_Red.svg"}
            alt="d"
          />
        </div>
        <input
          type="text"
          name={data.inputKey}
          value={value}
          onChange={onInputChange}
          placeholder={placeholder}
          className={`w-full border-0 placeholder:text-[#47556980] bg-transparent focus:outline-none placeholder:text-PH_Default placeholder:text-sm rounded-md px-2`}
        />
      </div>
    </fieldset>
  );
};

export default InputTextComponent;
